import type { JSONContent } from '@tiptap/core';

export const CONDITIONAL_BLOCK_NODE = 'conditionalBlock';
export const CONDITIONAL_BRANCH_NODE = 'conditionalBranch';
export const CONDITIONAL_INLINE_NODE = 'conditionalInline';

export type ConditionalBranchKind = 'if' | 'else';

export const conditionalBranch = (
	kind: ConditionalBranchKind,
	content: JSONContent[],
	attrs: { hidden?: boolean; menuOpen?: boolean } = {}
): JSONContent => ({
	type: CONDITIONAL_BRANCH_NODE,
	attrs: { kind, hidden: false, menuOpen: false, ...attrs },
	content: content.length > 0 ? content : [{ type: 'paragraph' }],
});

export const conditionalBlock = ({
	variable,
	ifContent,
	elseContent,
	menuOpen = false,
}: {
	variable: string;
	ifContent: JSONContent[];
	elseContent?: JSONContent[];
	menuOpen?: boolean;
}): JSONContent => ({
	type: CONDITIONAL_BLOCK_NODE,
	attrs: { variable },
	content: [
		conditionalBranch('if', ifContent, { menuOpen }),
		...(elseContent === undefined ? [] : [conditionalBranch('else', elseContent)]),
	],
});

export const emptyConditionalBlock = (variable: string): JSONContent =>
	conditionalBlock({ variable, menuOpen: true, ifContent: [] });

export const withoutMenuState = (document: JSONContent): JSONContent => {
	const attrs = { ...(document.attrs ?? {}) };
	delete attrs.menuOpen;
	return {
		...document,
		...(document.attrs ? { attrs } : {}),
		...(document.content ? { content: document.content.map(withoutMenuState) } : {}),
	};
};
